import { ITEM_MASTER_COLUMN_DEFS } from './itemMasterBulkUploadColumns';

const TEMPLATE_FILENAME = 'item_master_bulk_upload_template.csv';

const emptyRow = () => Object.fromEntries(ITEM_MASTER_COLUMN_DEFS.map(({ key }) => [key, '']));

const TEMPLATE_EXAMPLE_ROWS = [
    {
        action: 'add',
        internalName: 'Organic Marshmallows, Vanilla Bean, 4.5 Oz (TEMPLATE)',
        companySources: 'blue_apron',
        brand: 'Mojave Marshmallows (TEMPLATE)',
        basePrice: '13.25',
        categoryOne: 'Snacks & Candy',
        categoryTwo: 'Shelf Stable Candy',
        categoryThree: 'Truffles and Confections',
        sellableUnitsPerCase: '5',
        purchasingCaseUOM: 'ct',
        casesPerPallet: '192',
        poundsPerCase: '24',
        portionCount: '1',
        hi: '6',
        ti: '32',
        vendorGuaranteedDays: '70',
        unitLengthIn: '2.5',
        unitWidthIn: '5',
        unitHeightIn: '7',
        caseLengthIn: '6',
        caseWidthIn: '5',
        caseHeightIn: '6',
        receivingTempZone: 'Ambient',
        storageTempZone: 'Ambient (>55)',
        carrierShippingTempZone: 'Ambient',
        dbiShippingTempZone: 'Ambient',
        sellableUnitUOM: 'oz',
        sellableUnitSize: '4.5',
        skuDateType: 'EXPIRATION_DATE',
        cubeLevelPerSellableUnit: '5',
        customerGuaranteeDays: '14',
        unitWeightOz: '24',
        barcode: '123456',
        barcodeType: 'UPC',
        prop65Warning: 'no',
        prop65Alcohol: 'no',
        prop65Canned: 'no',
        prop65Food: 'no',
        prop65NonFood: 'no',
        sellOnPoQty: 'no',
        expireLifeDays: '365',
        dbiOnly: 'no',
        purchasingCasePackSize: '5',
        isBulkItem: 'no',
    },
    {
        action: 'update',
        externalSku: '117113',
        brand: 'Just Odds',
        categoryTwo: 'Shelf Stable Chips & Pretzels & Snacks',
        sellableUnitsPerCase: '30',
        casesPerPallet: '60',
    },
];

function buildCsvHeaders(columnDefs) {
    return columnDefs
        .map((column) => {
            if (column.required) {
                return `${column.label}*`;
            }
            if (column.conditionallyRequired) {
                return `${column.label}(*)`;
            }
            return column.label;
        })
        .join(',');
}

function formatCsvRow(columnDefs, row) {
    return columnDefs
        .map((column) => {
            const value = String(row[column.key] ?? '');
            if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                return `"${value.replace(/"/g, '""')}"`;
            }
            return value;
        })
        .join(',');
}

export function downloadItemMasterBulkUploadTemplate() {
    const headers = buildCsvHeaders(ITEM_MASTER_COLUMN_DEFS);
    const dataRows = TEMPLATE_EXAMPLE_ROWS.map((overrides) =>
        formatCsvRow(ITEM_MASTER_COLUMN_DEFS, { ...emptyRow(), ...overrides }),
    );
    const csvContent = [headers, ...dataRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = TEMPLATE_FILENAME;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
